// ==================================================
//  Q&A トグル
// ==================================================
document.addEventListener('DOMContentLoaded', () => {
  const faqItems = document.querySelectorAll('.js-staffvoiceFaq');
  faqItems.forEach((faq) => {
    faq.addEventListener('click', () => {
      faq.classList.toggle('is-active');
    });
  });
});
